import { isPricePresent } from './TvComparisonPriceUtil';
export const filterVisibleThemes = (themes) => themes.filter((name) => !['ALL', 'TV_ZANR_DEMO_TEENUSED', 'TV_ZANR_EUROOPA_KANALID', 'TV_ZANR_TAISKASVANUTELE'].includes(name));
export const filterChannelsNotAvailableInSelectedPackages = (visiblePackages, allPackages, channels) => {
    if (visiblePackages.length < allPackages.length) {
        return channels.filter((channel) => channel.packetPrices.some((price) => { var _a; return ((_a = price.price) === null || _a === void 0 ? void 0 : _a.isIncluded) !== false; }));
    }
    return channels;
};
export const resolveVisiblePacketNames = (packageNames, selectedPackages, packagePrices) => {
    const packageNameToOfferNameMap = {};
    packageNames.forEach((name, index) => (packageNameToOfferNameMap[name] = packagePrices[index].name));
    return packageNames.filter((name) => selectedPackages.includes(packageNameToOfferNameMap[name])).reverse();
};
export const mapChannelResults = (channelResultMap, defaultOrder) => {
    const channels = [];
    defaultOrder.forEach((channel) => {
        if (channelResultMap[channel.id]) {
            channels.push(channelResultMap[channel.id]);
        }
    });
    return channels;
};
export const mapThemeResults = (themeResultMap, defaultOrder) => {
    const themes = [];
    defaultOrder.forEach((theme) => {
        if (themeResultMap[theme.productSpecId]) {
            themes.push(themeResultMap[theme.productSpecId]);
        }
    });
    return themes;
};
export const filterThemesByCategories = (selectedCategories, categoriesLists, themePackages, themesResultMap) => {
    const themeIds = [];
    selectedCategories.forEach((categoryName) => {
        const categoryChannelIds = categoriesLists[categoryName];
        if (categoryChannelIds.length) {
            themePackages.filter((theme) => {
                for (let i = 0; i <= theme.channelIds.length; i++) {
                    if (categoryChannelIds.includes(`${theme.channelIds[i]}`)) {
                        themeIds.push(theme.productSpecId);
                        return;
                    }
                }
            });
        }
    });
    return filterChannelsByIds(themeIds, themesResultMap);
};
export const filterChannelsByCategories = (selectedCategories, categoriesLists, channelsResultMap) => {
    let matchedChannelIds = [];
    selectedCategories.forEach((categoryName) => {
        const categoryChannelIds = categoriesLists[categoryName];
        if (categoryChannelIds === null || categoryChannelIds === void 0 ? void 0 : categoryChannelIds.length) {
            matchedChannelIds = matchedChannelIds.concat(categoryChannelIds.map((channelId) => +channelId));
        }
    });
    return filterChannelsByIds(matchedChannelIds, channelsResultMap);
};
export const filterChannelsByIds = (includedChannels, channelsResultMap) => {
    const result = {};
    Object.keys(channelsResultMap).forEach((key) => {
        if (includedChannels === null || includedChannels === void 0 ? void 0 : includedChannels.includes(+key)) {
            result[+key] = channelsResultMap[+key];
        }
    });
    return result;
};
export const getChannelPrices = (channel, selectedPackages) => {
    if (channel.prices) {
        return Object.entries(channel.prices).filter(([packet, price]) => selectedPackages.includes(packet) && isPricePresent(price));
    }
    return null;
};
